import { ItemList } from '../../orm'
import { uniq, head, uniqBy, map, filter, get } from "lodash"

class AdminLedgerTransactionsList extends ItemList {
  getEntityKey() {
    return "admin/ledger_transaction"
  }

}

export const adminLedgerTransactionsList = new AdminLedgerTransactionsList("admin_ledger_transactions__default")
